export default "__VITE_ASSET__JDY72D0u__"